import { FORM_BUILDER_FIELD_TYPE, formBuilderMapper, ButtonSizeOptions } from "@loanbossinc/component-library";

export const rows = {
  title: {
    isTitle: true,
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TEXT,
        value: "Property Allocations",
        style: {
          marginLeft: "0",
          fontFamily: "Work Sans",
          fontStyle: "normal",
          fontWeight: "500",
          fontSize: "16px",
          lineHeight: "14px",
          textTransform: "uppercase",
          color: "#000000",
          marginBottom: "10px"
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.REFERENCE,
        referencedFieldPath: "loans.propertyallocations.header"
      }
    ]
  },

  propertyAllocations: {
    hasNestedRows: true,
    key: "properties",
    label: "Property and Allocation Percentage",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        style: { width: "100%" },
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
              key: "propertyId-Key",
              name: `properties[${index}].propertyId`,
              componentorder: 0,
              collectionname: "dealProperties",
              variant: "filled",
              displayWith: option => option.name,
              setValueWith: option => option.id
            })
          },
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.BUTTON,
              label: "Remove",
              key: "removeProperty",
              size: ButtonSizeOptions.sm,
              name: `properties[${index}].id`,
              onClick: (value, formik) => {
                if (value) {
                  const values = formik.values;
                  values.properties = values.properties.filter(item => item.id !== value);
                  formik.handleChange();
                  formik.handleBlur();
                }
              },
              style: { width: "132px", marginTop: "10px", float: "right" }
            })
          }
        ]
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.NESTED,
        Cell: formBuilderMapper,
        subComponents: [
          {
            map: index => ({
              type: FORM_BUILDER_FIELD_TYPE.PERCENT,
              key: "allocationPercent",
              label: "Allocation Percentage",
              name: `properties[${index}].allocationPercent`,
              decimals: "5",
              variant: "filled",
              style: { marginTop: "10px", marginLeft: "0" }
            })
          }
        ]
      }
    ]
  },

  addRecord: {
    key: "addRecord",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.BUTTON,
        label: "Add",
        hideLabel: true,
        size: ButtonSizeOptions.sm,
        onClick: (value, formik) => {
          const values = formik.values;
          const newItem = { loanId: 4430, propertyId: null, allocationPercent: null };
          values.properties.push(newItem);
          formik.handleChange();
          formik.handleBlur();
        },
        style: { width: "132px", marginTop: "10px", float: "right" }
      }
    ]
  }
};
